import { Field, Formik } from "formik";
import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import Put from "../../api/Put";
import { APPOINTMENT_UPDATE } from "../../api/Routes";
import * as Yup from 'yup';
import SimpleLoad from "../../loader/SimpleLoad";
import { toast } from "react-toastify";
import ComponentModalErrorSever from "../ComponentModalErrorSever";
import {canEditDoctor} from "../../utils/isDoctor";

function DoctorRecomendacionMedicaColombia({t, citaID, auth, medicalRecommendation, readOnly, cita}){
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)
    const [initialValues, setInitialValues] = useState({
        id: citaID,
        medicalRecommendation: medicalRecommendation ? medicalRecommendation : ''
    })

    


    return(
        <div className="p-3 pt-4 position-relative">
            { readOnly ? medicalRecommendation :
                <Row className="mt-3">
                <Col>
                    <Formik initialValues={ initialValues }
                        onSubmit={(values, { setSubmitting, setFieldValue }) => {                                                   
                            Put({url: APPOINTMENT_UPDATE, data: values, access_token: auth.data.access_token, header: true})
                            .then(resp => {
                                setSubmitting(false) 
                                toast.success("Acción exitosa", {autoClose: 3000})                               
                            })
                            .catch(error => {
                                setSubmitting(false)
                                setShowModalError(true)
                                if(error.response){
                                    setErrorServer(error.response)
                                }
                            })
                        }}>{({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue,
                            resetForm
                        })=>(
                            <Form onSubmit={handleSubmit}  className='mt-3'>
                                { isSubmitting && <SimpleLoad /> }
                                <Row>
                                    <Col xs="12" md="12">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary"> {t('recomendacion_medica')} </Form.Label>
                                            <Field
                                                type="text"
                                                className={`form-control input-form ${errors.medicalRecommendation && 'error'}`}
                                                name="medicalRecommendation"
                                            />
                                            { errors.medicalRecommendation && <div className="invalid-feedback d-block">{errors.medicalRecommendation}</div> }
                                        </Form.Group>
                                    </Col>
                                </Row>
                                {canEditDoctor(cita, auth) &&
                                <Row className="grupoBotones">
                                    <Col className="text-right">
                                        <Button variant="outline-success" className="ok-buttom" type="submit"> {t('guardar')} </Button>{' '}
                                    </Col>
                                </Row>}
                            </Form>
                        )}
                        </Formik>
                </Col>
            </Row>}
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </div>
    )

}

export default withTranslation()(DoctorRecomendacionMedicaColombia)